import memoize from 'lodash/memoize';
import { createSelector } from 'reselect';

const getFeedItems = ({ network }) => network.feed.items;
const getFeedPagination = ({ network }) => network.feed.pagination;
const getFeedLoading = ({ network }) => network.feed.loading;
const getFeedFilter = ({ network }) => network.feed.filter;

const getSettings = ({ network }) => network.settings.items;
const getSettingsLoading = ({ network }) => network.settings.loading;

const getAutoPostCandidateIds = ({ network }) => network.autoPostCandidates.ids;
const getAutoPostCandidatesLoading = ({ network }) => network.autoPostCandidates.loading;

const getLoadingByFeedItem = ({ network }) => network.loadingByFeedItem;
const getSavingByNetwork = ({ network }) => network.savingByNetwork;
const getFailedByNetwork = ({ network }) => network.failedByNetwork;

const getFeedItemLoadingSelector = createSelector(
  [getLoadingByFeedItem],
  (loading) => memoize((itemId) => !!loading[itemId]),
);

const getSettingsSavingSelector = createSelector(
  [getSavingByNetwork],
  (saving) => memoize((networkId) => !!saving[networkId]),
);

const getSettingsFailedSelector = createSelector(
  [getFailedByNetwork],
  (failed) => memoize((networkId) => !!failed[networkId]),
);

export default {
  getFeedItems,
  getFeedPagination,
  getFeedLoading,
  getFeedFilter,
  getSettings,
  getSettingsLoading,
  getAutoPostCandidateIds,
  getAutoPostCandidatesLoading,
  getFeedItemLoadingSelector,
  getSettingsSavingSelector,
  getSettingsFailedSelector,
};
